import { render } from "./MatchEventView.vue?vue&type=template&id=c43a48aa"
import script from "./MatchEventView.vue?vue&type=script&lang=js"
export * from "./MatchEventView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__